import { __decorate } from "tslib";
import { AutoEncoder, EnumDecoder, field } from '@simonbackx/simple-encoding';
import { ReduceablePrice } from './ReduceablePrice.js';
import { Formatter } from '@stamhoofd/utility';
export var GroupPriceDiscountType;
(function (GroupPriceDiscountType) {
    GroupPriceDiscountType["Fixed"] = "Fixed";
    GroupPriceDiscountType["Percentage"] = "Percentage";
})(GroupPriceDiscountType || (GroupPriceDiscountType = {}));
export class GroupPriceDiscount extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.value = ReduceablePrice.create({});
        this.type = GroupPriceDiscountType.Percentage;
    }
    calculateDiscount(price, member) {
        if (this.type === GroupPriceDiscountType.Fixed) {
            return Math.max(0, Math.min(price, this.value.forMember(member)));
        }
        return Math.max(0, Math.min(price, Math.round(price * this.value.forMember(member) / 10000)));
    }
    toString() {
        if (this.type === GroupPriceDiscountType.Percentage) {
            return Formatter.percentage(this.value.price);
        }
        return Formatter.price(this.value.price);
    }
}
__decorate([
    field({ decoder: ReduceablePrice })
], GroupPriceDiscount.prototype, "value", void 0);
__decorate([
    field({ decoder: new EnumDecoder(GroupPriceDiscountType) })
], GroupPriceDiscount.prototype, "type", void 0);
//# sourceMappingURL=GroupPriceDiscount.js.map